import type { CaseStatus } from '../../types';

interface StatusPillProps {
  status: CaseStatus | string;
  className?: string;
}

const statusConfig: Record<string, { bg: string; text: string; label: string }> = {
  pending: { bg: 'bg-gray-200 dark:bg-gray-700', text: 'text-gray-600 dark:text-gray-300', label: 'Pending' },
  downloading: { bg: 'bg-gray-200 dark:bg-gray-700', text: 'text-gray-600 dark:text-gray-300', label: 'Downloading' },
  downloaded: { bg: 'bg-gray-200 dark:bg-gray-700', text: 'text-gray-600 dark:text-gray-300', label: 'Downloaded' },
  translating: { bg: 'bg-gray-200 dark:bg-gray-700', text: 'text-gray-600 dark:text-gray-300', label: 'Translating' },
  translated: { bg: 'bg-gray-200 dark:bg-gray-700', text: 'text-gray-600 dark:text-gray-300', label: 'Translated' },
  generating_pdf: { bg: 'bg-gray-200 dark:bg-gray-700', text: 'text-gray-600 dark:text-gray-300', label: 'PDF Generated' },
  ready_for_review: { bg: 'bg-amber-500', text: 'text-white', label: 'Review' },
  approved: { bg: 'bg-emerald-500', text: 'text-white', label: 'Approved' },
  uploading: { bg: 'bg-amber-500', text: 'text-white', label: 'Uploading' },
  uploaded: { bg: 'bg-blue-500', text: 'text-white', label: 'Uploaded' },
  failed: { bg: 'bg-red-500', text: 'text-white', label: 'Failed' },
  returned: { bg: 'bg-orange-500', text: 'text-white', label: 'Returned' },
  lost: { bg: 'bg-gray-500', text: 'text-white', label: 'Lost' },
  found: { bg: 'bg-teal-500', text: 'text-white', label: 'Found' },
  // Salesforce statuses
  'In Queue': { bg: 'bg-gray-200 dark:bg-gray-700', text: 'text-gray-600 dark:text-gray-300', label: 'In Queue' },
  'Queued for Release': { bg: 'bg-blue-500', text: 'text-white', label: 'Queued for Release' },
  'Translation': { bg: 'bg-purple-500', text: 'text-white', label: 'Translation' },
};

export function StatusPill({ status, className = '' }: StatusPillProps) {
  const config = statusConfig[status] || { bg: 'bg-gray-200 dark:bg-gray-700', text: 'text-gray-600 dark:text-gray-300', label: status };

  return (
    <span
      className={`inline-block px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${config.bg} ${config.text} ${className}`}
    >
      {config.label}
    </span>
  );
}
